module.exports = __webpack_public_path__ + "static/media/rsz_moonriver.3746fa62.webp";